<template>
  <div>
    <b-col cols="12" class="m-0 p-0 pl-1">
      <div class="separador-div">
        <strong>CORPO</strong>
      </div>
    </b-col>
    <b-row class="adjust-a">
      <b-col cols="4" class="adjust-b">
        <div class="separador-div">
          <strong>PONTO</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>A</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>B</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>C</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>D</strong>
        </div>
      </b-col>
    </b-row>
    <b-row class="adjust-a">
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>LINHA 1</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>(mm)</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[0].a" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[0].b" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[0].c" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[0].d" />
      </b-col>
    </b-row>
    <b-row class="adjust-a">
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>LINHA 2</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>(mm)</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[1].a" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[1].b" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[1].c" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[1].d" />
      </b-col>
    </b-row>
    <b-row class="adjust-a">
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>LINHA 3</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>(mm)</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[2].a" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[2].b" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[2].c" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[2].d" />
      </b-col>
    </b-row>
    <b-row class="adjust-a">
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>LINHA 4</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>(mm)</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[3].a" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[3].b" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[3].c" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[3].d" />
      </b-col>
    </b-row>
    <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->

    <b-col cols="12" class="m-0 p-0 pl-1">
      <div class="separador-div">
        <strong>FUNIL</strong>
      </div>
    </b-col>
    <b-row class="adjust-a">
      <b-col cols="4" class="adjust-b">
        <div class="separador-div">
          <strong>PONTO</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>A</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>B</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>C</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>D</strong>
        </div>
      </b-col>
    </b-row>
    <b-row class="adjust-a">
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>LINHA 1</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>(mm)</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[6].a" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[6].b" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[6].c" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[6].d" />
      </b-col>
    </b-row>
    <b-row class="adjust-a">
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>LINHA 2</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>(mm)</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[7].a" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[7].b" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[7].c" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[7].d" />
      </b-col>
    </b-row>

    <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->

    <b-col cols="12" class="p-0 pl-1">
      <div class="separador-div">
        <strong>CALOTA A</strong>
      </div>
    </b-col>
    <b-row class="adjust-a">
      <b-col cols="4" class="adjust-b">
        <div class="separador-div">
          <strong>ZONAS DE A</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>A</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>B</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>C</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>D</strong>
        </div>
      </b-col>
    </b-row>
    <b-row class="adjust-a">
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>PONTO</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>(mm)</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[4].a" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[4].b" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[4].c" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[4].d" />
      </b-col>
    </b-row>

    <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->

    <b-row class="adjust-a">
      <b-col cols="12" class="p-0 pl-1">
        <div class="separador-div">
          <strong>CALOTA B</strong>
        </div>
      </b-col>
      <b-col cols="4" class="adjust-b">
        <div class="separador-div">
          <strong>ZONAS DE B</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>A</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>B</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>C</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>D</strong>
        </div>
      </b-col>
    </b-row>
    <b-row class="adjust-a">
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>PONTO</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <div class="separador-div">
          <strong>(mm)</strong>
        </div>
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[5].a" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[5].b" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[5].c" />
      </b-col>
      <b-col cols="2" class="adjust-b">
        <b-form-input class="text-center" v-model="medicoes[5].d" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "MedicaoVasoReport",

  data() {
    return {
      medicoes: [
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" },
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" },
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" },
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" },
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" },
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" },
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" },
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" },
      ],
    };
  },

  methods: {
    update(medicoes) {
      this.medicoes = medicoes;
    },
  },
};
</script>

<style lang="scss" scoped>
#screen-form {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 82vh;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  background-color: #ffbf00;
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.adjust-a {
  margin: 0;
  margin-left: 0.2rem;
  margin-right: 0.2rem;
}

.adjust-b {
  margin: 0;
  padding: 0.1rem;
}
</style>
